// utils/analytics.js — fire-and-forget event tracking to our own backend
import api from './api';

export function track(event, properties = {}) {
  // Best-effort: never throw, never block the UI
  try {
    api.post('/analytics/event', { event, properties }).catch(() => {});
  } catch {}
}
